import ChairOutlined from '../../src/legacy/ChairOutlined.tsx';
export default ChairOutlined;
